import { Injectable } from '@angular/core';

import { MemoryMapCacheRepository } from './memory-map-cache.repository';
import { TraderInterface } from '../data';

@Injectable()
export class TraderCacheRepository extends MemoryMapCacheRepository<TraderInterface[]> {
    getKey(external = false): string {
        return 'TraderCacheRepository' + (external ? 'External' : '');
    }
}
